import React, { useEffect, useRef } from "react"
import { ContentSection, Layout, SEO, Sponsor, Wordmark } from "components"
import { Accessibility } from "svgs"
import Logos from "data/sponsors"
import donors from "data/donors"
import * as data from "data"
import styles from "./styles/index.module.scss"

const IndexPage = () => {
  const gridAreas = useRef(new Set(["a", "b", "c", "d", "e", "f"]))
  const content = Object.values({ ...data })
  const sponsors = Object.values({ ...Logos })

  const winsize = () => window.innerWidth

  const handleResize = () => {
    getRandomPosition()
    winsize()
  }

  const getRandomPosition = () => {
    const GRID_AREAS = gridAreas.current
    const SET_ARRAY = Array.from(GRID_AREAS)
    const RANDOM = Math.floor(Math.random() * SET_ARRAY.length) + 1
    const RANDOM_POSITION = SET_ARRAY[RANDOM]

    GRID_AREAS.delete(RANDOM_POSITION)

    return RANDOM_POSITION
  }

  useEffect(() => {
    window.addEventListener("resize", handleResize)

    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  return (
    <Layout>
      <SEO title="Black Futurism 2019" />

      <section className={styles.wordmark}>
        <Wordmark />
      </section>

      <div className={styles.container}>
        <section className={styles.grid}>
          {content.map((section, index) => {
            const position = getRandomPosition()

            return (
              <ContentSection
                content={section}
                key={index}
                index={index}
                position={position}
                getRandomPosition={getRandomPosition}
              />
            )
          })}
        </section>

        <section className={styles.sponsors}>
          <h3 className={styles.overline}>Our Sponsors</h3>
          <div className={styles.sponsorsGrid}>
            {sponsors.map((sponsor, i) => (
              <Sponsor key={i} content={sponsor} />
            ))}
          </div>
        </section>

        <section className={styles.donors}>
          <h3 className={styles.overline}>Credits</h3>
          <div className={styles.donorsList}>
              <h4 key="1" className={styles.donorName}>
                Rania Karamallah - Marketing Chair
              </h4>
              <h4 key="2" className={styles.donorName}>
                <a href="mailto:hello@qusai.design" title="hello@qusai.design">Qusai Akoud</a> - Website Design & Development
              </h4>
          </div>
        </section>

        <section className={styles.donors}>
          <h3 className={styles.overline}>Our Donors</h3>
          <div className={styles.donorsList}>
            {donors.map((donor, i) => (
              <h4 key={i} className={styles.donorName}>
                {donor}
              </h4>
            ))}
          </div>
        </section>
      </div>
      <div className={styles.disclaimer}>
        <Accessibility className={styles.disclaimerIcon} />
        <p>
          For any accessibility accommodations please contact the events office
          at (617) 496-2414 or send an email to{" "}
          <a
            href="mailto:events@gsd.harvard.edu"
            title="events@gsd.harvard.edu"
          >
            events@gsd.harvard.edu
          </a>
          .
        </p>
      </div>
    </Layout>
  )
}

export default IndexPage
